import jsPDF from 'jspdf';
import autoTable from 'jspdf-autotable';

export const generateQuotePDF = (quote, companyInfo = {}) => {
  const doc = new jsPDF();
  
  // Brand Colors
  const primaryColor = [58, 41, 166]; // #3a29a6 Governor Bay
  const secondaryColor = [242, 100, 68]; // #f26444 Flamingo
  
  // Page dimensions
  const pageWidth = doc.internal.pageSize.width;
  const marginLeft = 20;
  const marginRight = 20;
  const contentWidth = pageWidth - marginLeft - marginRight;
  
  let yPos = 20;
  
  // ===== HEADER SECTION =====
  // Company Logo (using text representation)
  doc.setFillColor(...primaryColor);
  doc.rect(marginLeft, yPos, 12, 12, 'F');
  doc.setTextColor(255, 255, 255);
  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('H', marginLeft + 4, yPos + 8);
  
  // Company Name
  doc.setTextColor(0, 0, 0);
  doc.setFontSize(24);
  doc.setFont('helvetica', 'bold');
  doc.text('HOKICO', marginLeft + 15, yPos + 9);
  
  // Tagline
  doc.setFontSize(9);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(100, 100, 100);
  doc.text('Premium POSM Solutions', marginLeft + 15, yPos + 14);
  
  // Quote ID and Date (right aligned)
  doc.setFontSize(10);
  doc.setTextColor(0, 0, 0);
  doc.setFont('helvetica', 'bold');
  const quoteIdText = `Quote #${quote.id.substring(0, 8).toUpperCase()}`;
  doc.text(quoteIdText, pageWidth - marginRight, yPos + 5, { align: 'right' });
  
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(100, 100, 100);
  const dateText = new Date(quote.created_at).toLocaleDateString('en-IN', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });
  doc.text(dateText, pageWidth - marginRight, yPos + 10, { align: 'right' });
  
  yPos += 25;
  
  // Horizontal line
  doc.setDrawColor(...primaryColor);
  doc.setLineWidth(0.5);
  doc.line(marginLeft, yPos, pageWidth - marginRight, yPos);
  
  yPos += 10;
  
  // ===== CLIENT INFORMATION =====
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...primaryColor);
  doc.text('CLIENT INFORMATION', marginLeft, yPos);
  
  yPos += 8;
  
  doc.setFontSize(10);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(0, 0, 0);
  
  const clientInfo = [
    { label: 'Company:', value: quote.client_company || 'N/A' },
    { label: 'Email:', value: quote.client_email },
    { label: 'Status:', value: quote.status.toUpperCase() }
  ];
  
  clientInfo.forEach(item => {
    doc.setFont('helvetica', 'bold');
    doc.text(item.label, marginLeft, yPos);
    doc.setFont('helvetica', 'normal');
    doc.text(item.value, marginLeft + 25, yPos);
    yPos += 6;
  });
  
  yPos += 5;
  
  // ===== PRODUCTS TABLE =====
  doc.setFontSize(12);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...primaryColor);
  doc.text('PRODUCTS REQUESTED', marginLeft, yPos);
  
  yPos += 8;
  
  // Prepare table data
  const tableData = quote.products.map((product, index) => [
    index + 1,
    product.product_name,
    product.quantity,
    product.notes || '-'
  ]);
  
  const tableResult = autoTable(doc, {
    startY: yPos,
    head: [['#', 'Product Name', 'Quantity', 'Notes']],
    body: tableData,
    theme: 'striped',
    headStyles: {
      fillColor: primaryColor,
      textColor: [255, 255, 255],
      fontSize: 10,
      fontStyle: 'bold',
      halign: 'left'
    },
    bodyStyles: {
      fontSize: 9,
      textColor: [0, 0, 0]
    },
    columnStyles: {
      0: { cellWidth: 10, halign: 'center' },
      1: { cellWidth: 80 },
      2: { cellWidth: 25, halign: 'center' },
      3: { cellWidth: 55 }
    },
    margin: { left: marginLeft, right: marginRight }
  });
  
  yPos = doc.lastAutoTable.finalY + 10;
  
  // ===== ADDITIONAL NOTES =====
  if (quote.additional_notes) {
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.setTextColor(...primaryColor);
    doc.text('ADDITIONAL NOTES', marginLeft, yPos);
    
    yPos += 8;
    
    doc.setFontSize(9);
    doc.setFont('helvetica', 'normal');
    doc.setTextColor(60, 60, 60);
    
    // Wrap text
    const splitNotes = doc.splitTextToSize(quote.additional_notes, contentWidth);
    doc.text(splitNotes, marginLeft, yPos);
    
    yPos += (splitNotes.length * 5) + 10;
  }
  
  // ===== FOOTER SECTION =====
  // Move to bottom of page
  const pageHeight = doc.internal.pageSize.height;
  yPos = pageHeight - 40;
  
  // Divider line
  doc.setDrawColor(200, 200, 200);
  doc.setLineWidth(0.3);
  doc.line(marginLeft, yPos, pageWidth - marginRight, yPos);
  
  yPos += 8;
  
  // Company Info Footer
  doc.setFontSize(8);
  doc.setFont('helvetica', 'bold');
  doc.setTextColor(...primaryColor);
  doc.text('HOKICO GLOBAL PRIVATE LIMITED', marginLeft, yPos);
  
  yPos += 5;
  
  doc.setFont('helvetica', 'normal');
  doc.setFontSize(7);
  doc.setTextColor(80, 80, 80);
  
  const footerInfo = [
    '26+ Years of Excellence | 1,350+ Projects | 115+ Cities',
    'OCUS Quantum, 15th Floor, Orchid Island, Sector-50, Gurugram - 122018, Haryana',
    'Email: sales@hokico.in | Phone: +91 8882466777 | Website: www.hokico.in'
  ];
  
  footerInfo.forEach(line => {
    doc.text(line, marginLeft, yPos);
    yPos += 4;
  });
  
  // ===== SAVE PDF =====
  const fileName = `Hokico_Quote_${quote.id.substring(0, 8)}_${new Date().toISOString().split('T')[0]}.pdf`;
  doc.save(fileName);
  
  return fileName;
};
